<div *ngIf="showField()" class="form-component-input-group">
  <app-field-header *ngIf="!model.isInsideRepeatable" [model]="model" [disabled]="isInputHidden()"></app-field-header>

  <ng-container [ngSwitch]="inputType" *ngIf="!isInputHidden()">
    <app-select
      *ngSwitchCase="CodelistComponentType.Select"
      [control]="control"
      [options]="codeListItems"
      [ariaLabel]=""
      [isMandatory]="model.isMandatory"
      [isReadonly]="model.isReadonly && !userSettings?.superEditMode"
      [hasError]="hasInputError()"
      [alwaysShowId]="userSettings?.supportMode"
      [htmlId]="htmlId">
    </app-select>

    <app-autocomplete
      *ngSwitchCase="CodelistComponentType.Autocomplete"
      [control]="control"
      [codeListItems]="codeListItems"
      [model]="model"
      [hasError]="hasInputError()"
      [htmlId]="htmlId">
    </app-autocomplete>

    <app-radio-button
      *ngSwitchCase="CodelistComponentType.RadioButton"
      [control]="control"
      [options]="codeListItems"
      [isMandatory]="model.isMandatory"
      [isReadonly]="model.isReadonly  && !userSettings?.superEditMode"
      [hasError]="hasInputError()"
      [htmlId]="htmlId">
    </app-radio-button>
  </ng-container>


  <app-forbidden-info [model]="model" [userSettings]="userSettings" *ngIf="isInputHidden()"></app-forbidden-info>
  <app-validation-message [model]="model"></app-validation-message>
</div>
